import { render, staticRenderFns } from "./ChildTable.vue?vue&type=template&id=58524808&scoped=true&"
import script from "./ChildTable.vue?vue&type=script&lang=js&"
export * from "./ChildTable.vue?vue&type=script&lang=js&"
import style0 from "styles/views/orderAdmin/childTable.css?vue&type=style&index=0&id=58524808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58524808",
  null
  
)

export default component.exports